import { render, staticRenderFns } from "./toPage.vue?vue&type=template&id=7f7a6a20&scoped=true"
import script from "./toPage.vue?vue&type=script&lang=js"
export * from "./toPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f7a6a20",
  null
  
)

export default component.exports